var _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2762 2.79015C15.2614 2.73744 15.2358 2.68836 15.2012 2.64597C15.1665 2.60358 15.1235 2.56881 15.0747 2.54383C15.026 2.51884 14.9726 2.50418 14.918 2.50077C14.8634 2.49736 14.8086 2.50527 14.7571 2.524C14.6527 2.56966 14.5694 2.65312 14.5239 2.75764C14.4784 2.86216 14.4741 2.98001 14.5118 3.08757L15.2762 2.79015ZM14.5118 3.08757L16.0604 7.77227L16.8248 7.47486L15.2762 2.79015L14.5118 3.08757ZM18.5335 9.81248L22.0087 10.0805L22.0665 9.20155L18.5903 8.92877L18.5335 9.81248ZM16.0604 7.77227C16.2253 8.31798 16.5473 8.80259 16.9875 9.16487C17.4277 9.52715 17.9663 9.75086 18.5335 9.80774L18.5903 8.92877C18.1852 8.88814 17.8011 8.72835 17.4867 8.46957C17.1723 8.2108 16.9426 7.86466 16.8248 7.47486L16.0604 7.77227Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6033 18.1686L6.78983 18.1686M21.5951 18.1686L22.6479 18.1686C23.0015 18.1342 23.3274 17.9622 23.5552 17.6897C23.7831 17.4171 23.8947 17.0659 23.8659 16.7118L23.8659 13.2689C23.8672 12.9884 23.7979 12.7122 23.6642 12.4657L22.5115 10.3762L19.8395 3.83127C19.7595 3.60123 19.6125 3.40042 19.4173 3.25473C19.2222 3.10904 18.9879 3.02514 18.7446 3.01386L2.3519 3.01386C1.99832 3.04824 1.67243 3.22026 1.44455 3.49279C1.21667 3.76532 1.10508 4.11652 1.13384 4.4706L1.13384 16.7118C1.10507 17.0659 1.21667 17.4171 1.44455 17.6897C1.67243 17.9622 1.99832 18.1342 2.3519 18.1686L2.88359 18.1686",
    stroke: "black",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84475 17.7642C3.85992 17.7642 3.06156 18.5626 3.06156 19.5474C3.06156 20.5322 3.85992 21.3306 4.84475 21.3306C5.82958 21.3306 6.62794 20.5322 6.62794 19.5474C6.62794 18.5626 5.82958 17.7642 4.84475 17.7642ZM1.89209 19.5474C1.89209 17.9167 3.21404 16.5947 4.84475 16.5947C6.47546 16.5947 7.79741 17.9167 7.79741 19.5474C7.79741 21.1781 6.47546 22.5 4.84475 22.5C3.21404 22.5 1.89209 21.1781 1.89209 19.5474Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6363 17.7641C18.6514 17.7641 17.8531 18.5625 17.8531 19.5473C17.8531 20.5322 18.6514 21.3305 19.6363 21.3305C20.6211 21.3305 21.4194 20.5322 21.4194 19.5473C21.4194 18.5625 20.6211 17.7641 19.6363 17.7641ZM16.6836 19.5473C16.6836 17.9166 18.0055 16.5947 19.6363 16.5947C21.267 16.5947 22.5889 17.9166 22.5889 19.5473C22.5889 21.178 21.267 22.5 19.6363 22.5C18.0055 22.5 16.6836 21.178 16.6836 19.5473Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.46826,
    y: 7.17786,
    width: 11.6947,
    height: 3.5084,
    rx: 1.7542,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.f3207037c95486e954130ee3314f1dd2.svg";
export { ForwardRef as ReactComponent };